import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const SMSNotificationSettings = ({ settings, setSettings, updateSettings }) => {
  const isTwilioConfigured = () => {
    // Check if Twilio env variables are set (we'll check this from backend)
    // For now, just show the UI
    return true;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle style={{ fontSize: '1.25rem' }}>📱 SMS Notifications</CardTitle>
      </CardHeader>
      <CardContent>
        <div style={{ display: 'grid', gap: '1.5rem' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', fontSize: '0.875rem' }}>
              Admin Phone Number
            </label>
            <input
              type="tel"
              value={settings.admin_phone || ''}
              onChange={(e) => setSettings({...settings, admin_phone: e.target.value})}
              placeholder="+16026960694"
              style={{
                width: '100%',
                maxWidth: '300px',
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '0.875rem'
              }}
            />
            <p style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.25rem' }}>
              Format: +1 followed by 10 digits (e.g., +16026960694)
            </p>
          </div>

          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={settings.sms_notifications || false}
                onChange={(e) => setSettings({...settings, sms_notifications: e.target.checked})}
                style={{ width: '18px', height: '18px' }}
              />
              <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                Enable SMS Notifications for New Bookings
              </span>
            </label>
          </div>

          <div style={{ 
            padding: '1rem', 
            backgroundColor: '#eff6ff', 
            borderRadius: '6px',
            border: '1px solid #3b82f6'
          }}>
            <h4 style={{ fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem', color: '#1e40af' }}>
              📋 Twilio Setup Status
            </h4>
            <p style={{ fontSize: '0.75rem', color: '#1e40af', marginBottom: '0.5rem' }}>
              To receive SMS notifications, you need to configure Twilio credentials.
            </p>
            <p style={{ fontSize: '0.75rem', color: '#1e40af' }}>
              📄 <strong>Setup Guide:</strong> <code>/app/TWILIO_SETUP_GUIDE.md</code>
            </p>
            <p style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.5rem' }}>
              Cost: ~$3-10/month | Get instant text for every new booking!
            </p>
          </div>

          <div style={{ 
            padding: '1rem', 
            backgroundColor: '#f0fdf4', 
            borderRadius: '6px',
            border: '1px solid #10b981'
          }}>
            <h4 style={{ fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem', color: '#065f46' }}>
              📬 What You'll Receive
            </h4>
            <div style={{ 
              fontSize: '0.75rem', 
              color: '#065f46',
              fontFamily: 'monospace',
              backgroundColor: 'white',
              padding: '0.75rem',
              borderRadius: '4px',
              marginTop: '0.5rem',
              whiteSpace: 'pre-line'
            }}>
{`🆕 ReturnPal Booking!
📋 #RP-12345
👤 John Smith
📦 3 package(s)
📍 85254 - Residential
   123 Main St, Apt 5
🕐 Tomorrow, 4-6 PM
💰 $49.99`}
            </div>
          </div>

          <Button
            onClick={() => updateSettings(settings)}
            style={{
              backgroundColor: '#10b981',
              color: 'white',
              padding: '0.75rem 1.5rem',
              width: 'fit-content'
            }}
          >
            Save SMS Settings
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default SMSNotificationSettings;
